/**
 * Keys for what a patient keeps only on this device (diary, mission history). Each key
 * carries the user id, so a second account on a shared device never sees the first one's
 * entries.
 */

export function userKey(base: string, userId: string): string {
  const key = `${base}:${userId}`;
  // Entries saved before keys were per user move to whoever opens them first, once.
  try {
    const legacy = localStorage.getItem(base);
    if (legacy !== null) {
      if (localStorage.getItem(key) === null) localStorage.setItem(key, legacy);
      localStorage.removeItem(base);
    }
  } catch { /* private mode: nothing to move */ }
  return key;
}
